/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_YesInputs */

const en_manual_qc_yes = /** @type {(inputs: Manual_Qc_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const fr_manual_qc_yes = /** @type {(inputs: Manual_Qc_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

const de_manual_qc_yes = /** @type {(inputs: Manual_Qc_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const it_manual_qc_yes = /** @type {(inputs: Manual_Qc_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SÌ`)
};

const ru_manual_qc_yes = /** @type {(inputs: Manual_Qc_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да`)
};

const es_manual_qc_yes = /** @type {(inputs: Manual_Qc_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const zh_cn2_manual_qc_yes = /** @type {(inputs: Manual_Qc_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的`)
};

const ja_manual_qc_yes = /** @type {(inputs: Manual_Qc_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい`)
};

const hi_manual_qc_yes = /** @type {(inputs: Manual_Qc_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाँ`)
};

const pt_pt2_manual_qc_yes = /** @type {(inputs: Manual_Qc_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Manual_Qc_YesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_yes = /** @type {((inputs?: Manual_Qc_YesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_YesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_yes(inputs)
	if (locale === "de") return de_manual_qc_yes(inputs)
	if (locale === "it") return it_manual_qc_yes(inputs)
	if (locale === "ru") return ru_manual_qc_yes(inputs)
	if (locale === "es") return es_manual_qc_yes(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_yes(inputs)
	if (locale === "ja") return ja_manual_qc_yes(inputs)
	if (locale === "hi") return hi_manual_qc_yes(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_yes(inputs)
	return en_manual_qc_yes(inputs)
});